import { render, staticRenderFns } from "./FormattingInput.vue?vue&type=template&id=512646c8"
import script from "./FormattingInput.vue?vue&type=script&lang=js"
export * from "./FormattingInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports